export const NotificationSymbols = {
    NotificationService: Symbol.for("NotificationService")
}